const baseUrl = process.env.REACT_APP_BASE_URL || 'https://localhost:44333/api/';

const TransactionApiService = {
  // Method for handling the signup API call


  Get: async () => {
    try {
      const apiEndpoint = `${baseUrl}Transaction/Get`; // Complete URL for the test endpoint

      const response = await fetch(apiEndpoint, {
        method: 'GET', // Correctly capitalized method
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  GetById: async (transactionId) => {
    try {
      const apiEndpoint = `${baseUrl}Transaction/GetByTransaction/${transactionId}`; // Complete URL for the test endpoint

      const response = await fetch(apiEndpoint, {
        method: 'GET', // Correctly capitalized method
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  GetAllTransactionByUserId: async (data) => {
    try {
      let apiEndpoint;
      if (data == null) {
        apiEndpoint = `${baseUrl}Transaction/Get`; // Complete URL for the test endpoint
      } else {
        apiEndpoint = `${baseUrl}Transaction/GetByUser/${data}`; // Complete URL for the test endpoint
      }
      const response = await fetch(apiEndpoint, {
        method: 'GET', // Correctly capitalized method
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },
  PayInvoice: async (data) => {
    try {
      let apiEndpoint = `${baseUrl}Transaction/PayInvoice`; // Complete URL for the test endpoint;

      const response = await fetch(apiEndpoint, {
        method: 'POST', // Correctly capitalized method
        body: data
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },
  GetInvoiceInfo : async (id) => {
    try {
      let apiEndpoint = `${baseUrl}Transaction/GetInvoice?id=${id}`; // Complete URL for the test endpoint
      const response = await fetch(apiEndpoint, {
        method: 'GET', // Correctly capitalized method
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  }

};

export default TransactionApiService;
